/* Fenêtre « Commander » (Maurice, 2026-10-12) : on choisit le nombre d'unités avant le paiement.
   Tout bouton « Commander… » qui mène au paiement ouvre cette fenêtre au lieu de partir directement.
   Données posées par snippets/ls-commande.liquid dans window.LS_CMD (stock, prix, variante). */
(function(){
  var D = window.LS_CMD;
  if (!D || !D.variante) return;
  var stock = Math.max(0, parseInt(D.stock, 10) || 0);
  var n = 1, fenetre, ouvreur;

  function euros(centimes){
    try { return new Intl.NumberFormat('fr-FR', {style: 'currency', currency: D.devise || 'EUR',
      maximumFractionDigits: centimes % 100 ? 2 : 0}).format(centimes / 100); }
    catch (e) { return (centimes / 100) + ' €'; }
  }
  function ico(d){
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>';
  }
  var I = {
    x: '<path d="M18 6 6 18"/><path d="m6 6 12 12"/>',
    moins: '<path d="M5 12h14"/>',
    plus: '<path d="M5 12h14"/><path d="M12 5v14"/>',
    fleche: '<path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>',
    camion: '<path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/>',
    colis: '<path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z"/><path d="M12 22V12"/><path d="m3.3 7 7.703 4.734a2 2 0 0 0 1.994 0L20.7 7"/><path d="m7.5 4.27 9 5.15"/>'
  };

  function construit(){
    fenetre = document.createElement('div');
    fenetre.className = 'lsc-voile';
    fenetre.hidden = true;
    var dispo = stock > 0
      ? stock + ' unité' + (stock > 1 ? 's' : '') + ' disponible' + (stock > 1 ? 's' : '')
      : 'Rupture de stock';
    fenetre.innerHTML =
      '<div class="lsc" role="dialog" aria-modal="true" aria-labelledby="lsc-titre">' +
        '<button class="lsc-x" type="button" aria-label="Fermer">' + ico(I.x) + '</button>' +
        '<div class="lsc-tete">' +
          '<img class="lsc-photo" src="' + D.photo + '" alt="LIMA SHIELD">' +
          '<div><p class="lsc-sur">Bouclier sonore anti-intrusion</p>' +
          '<h2 id="lsc-titre">LIMA SHIELD</h2>' +
          '<p class="lsc-prix">' + euros(D.prix) + ' <span>TTC l’unité</span></p></div>' +
        '</div>' +
        '<div class="lsc-ligne lsc-qte">' +
          '<span class="lsc-lib">Nombre d’unités</span>' +
          '<div class="lsc-pas">' +
            '<button type="button" class="lsc-moins" aria-label="Une unité de moins">' + ico(I.moins) + '</button>' +
            '<output class="lsc-n" aria-live="polite">1</output>' +
            '<button type="button" class="lsc-plus" aria-label="Une unité de plus">' + ico(I.plus) + '</button>' +
          '</div>' +
        '</div>' +
        '<ul class="lsc-infos">' +
          '<li><span class="lsc-ico">' + ico(I.colis) + '</span><span><strong>' + dispo + '</strong>' +
            (stock > 0 ? ' · expédition depuis notre entrepôt en France' : ' · nouvelle série en production') + '</span></li>' +
          '<li><span class="lsc-ico">' + ico(I.camion) + '</span><span><strong>France : 2 à 3 jours ouvrés</strong>' +
            ' · Union européenne : 3 à 5 jours ouvrés · livraison ' + euros(D.port) + '</span></li>' +
        '</ul>' +
        '<div class="lsc-ligne lsc-total"><span class="lsc-lib">Total</span><strong class="lsc-somme"></strong></div>' +
        '<a class="lsc-cta" href="#">Passer au paiement' + ico(I.fleche) + '</a>' +
        '<p class="lsc-note">Paiement sécurisé. Livraison ajoutée à l’étape suivante.</p>' +
      '</div>';
    document.body.appendChild(fenetre);
    fenetre.addEventListener('click', function(e){ if (e.target === fenetre) ferme(); });
    fenetre.querySelector('.lsc-x').addEventListener('click', ferme);
    fenetre.querySelector('.lsc-moins').addEventListener('click', function(){ regle(n - 1); });
    fenetre.querySelector('.lsc-plus').addEventListener('click', function(){ regle(n + 1); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !fenetre.hidden) ferme(); });
  }

  function regle(v){
    var max = Math.max(1, stock);
    n = Math.min(max, Math.max(1, v));
    fenetre.querySelector('.lsc-n').textContent = n;
    fenetre.querySelector('.lsc-moins').disabled = n <= 1;
    fenetre.querySelector('.lsc-plus').disabled = n >= max;
    fenetre.querySelector('.lsc-somme').textContent = euros(D.prix * n);
    var cta = fenetre.querySelector('.lsc-cta');
    if (stock > 0) cta.setAttribute('href', D.panier + '/' + D.variante + ':' + n);
    else { cta.removeAttribute('href'); cta.classList.add('off'); }
  }

  function ouvre(a){
    if (!fenetre) construit();
    ouvreur = a;
    regle(1);
    fenetre.hidden = false;
    document.documentElement.classList.add('lsc-ouvert');
    fenetre.querySelector('.lsc-plus').focus();
  }
  function ferme(){
    fenetre.hidden = true;
    document.documentElement.classList.remove('lsc-ouvert');
    if (ouvreur && ouvreur.focus) ouvreur.focus();
  }

  /* un bouton « Commander… » qui part vers le paiement (/cart/<variante>:1) ou vers #commander */
  document.addEventListener('click', function(e){
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || (fenetre && fenetre.contains(a))) return;
    var h = a.getAttribute('href') || '';
    if (!/^\s*Commander/.test(a.textContent || '')) return;
    if (h.indexOf('/cart/' + D.variante + ':') === -1 && h !== '#commander' && h !== '#') return;
    e.preventDefault();
    ouvre(a);
  }, true);
})();
